/**
 * The string's UTF-8 bytes, one character per byte. qr-code-styling writes only each
 * character's low byte into the code, so this is how it gets UTF-8, as ecommerce-api
 * encodes a printed unit's QR, instead of losing every character beyond Latin-1.
 */
export default function utf8ByteString(value: string): string {
  return Array.from(new TextEncoder().encode(value), (byte) => String.fromCharCode(byte)).join('');
}
